import { APIEvent } from '../events/apiEvent'
import { StatusBarEvent } from '../events/statusBarEvent'
import { EventBus } from '../event-bus'
import router from '../router'

export default {
  data () {
    return {
      searchDeviceID: '',
      tenantSelection: null,
      startOffset: 0,
      perPage: 20,
      currentPage: 1,
      hasNextPage: false,
      pageNumber: 1,
      roleSelection: this.$store.state.roleID,
      apiSelection: this.$store.state.roleID,
      records: [],
      APIs: [],
      roleSelected: 1,
      roleSelectedName: '',
      showModal: false,
      newRoleName: '',
      newRoleDescription: ''
    }
  },
  computed: {
    tenants () { return this.$store.state.tenantsList },
    userRoles () {
      return this.$store.state.userRoles.sort(this.sort)
    },
    apiList () { return this.$store.state.apiList }
  },
  mounted () {
    if (window.localStorage.getItem('token') === null) {
      this.$store.dispatch(APIEvent.LOGOUT, {})
    } else {
      this.fetchAPIs()
      if (this.$store.state.userRoles.length < 1) {
        let options = {}
        options.start_record = '0'
        this.$store.dispatch(APIEvent.FETCH_USER_ROLES, options)
          .then(() => {
            this.fetchUsers()
          })
      } else {
        this.fetchUsers()
      }
    }
  },
  methods: {
    fetchUsers: function () {
      let options = {}
      options.fetch_size = this.perPage.toString()
      options.start_record = this.startOffset.toString()
      options.role_id = this.roleSelection.toString()
      this.$store.dispatch(APIEvent.FETCH_USERS, options)
        .then((res) => {
          this.hasNextPage = res.data.LastPage === '0'
        })
        .catch(this.handleError)
    },
    onChange: function (event) {
      this.roleSelection = parseInt(event.target.value)
      EventBus.$emit('role-selected', this.roleSelection)
      this.startOffset = 0
      this.pageNumber = 1
    },
    onChange2: function (event) {
      this.apiSelection = parseInt(event.target.value)
      EventBus.$emit('api-selected', this.apiSelection)
      this.startOffset = 0
      this.pageNumber = 1
    },
    fetchAPIs: function () {
      let APIs = this.APIs
      this.$store.dispatch(APIEvent.FETCH_API)
        .then((res) => {
          this.records = res.data.list.records
          let apis = this.records.sort(this.compare)
          for (let i = 0; i < apis.length; i++) {
            let apiID = apis[i].id
            let apiName = apis[i].service + '/' + apis[i].object + '/' + apis[i].event
            APIs.push({apiName, apiID})
          }
          this.hasNextPage = res.data.LastPage === '0'
        })
        .catch(this.handleError)
    },
    createRole: function () {
      if (this.newRoleName !== '' && this.newRoleDescription !== '') {
        let options = {}
        options.role_name = this.newRoleName
        options.role_description = this.newRoleDescription
        this.$store.dispatch(APIEvent.CREATE_ROLE, options)
          .then((res) => {
            if (res.data.id) {
              EventBus.$emit(StatusBarEvent.SUCCESS, 'Role successfully created')
            }
          })
          .catch(this.handleError)
      } else {
        let message = 'Mandatory fields are missing'
        EventBus.$emit(StatusBarEvent.ERROR, message)
      }
    },
    clearInput: function () {
      this.newRoleName = ''
    },
    showUsers: function () {
      EventBus.$emit('role-selected', this.roleSelection)
      router.push('/userlist:roleID=' + this.roleSelection)
    },
    compare: function (obj1, obj2) {
      const serviceA = obj1.service
      const serviceB = obj2.service

      let comparison = 0
      if (serviceA > serviceB) {
        comparison = 1
      } else if (serviceA < serviceB) {
        comparison = -1
      }
      return comparison
    },
    sort: function (obj1, obj2) {
      const nameA = obj1.name
      const nameB = obj2.name

      let comparison = 0
      if (nameA > nameB) {
        comparison = 1
      } else if (nameA < nameB) {
        comparison = -1
      }
      return comparison
    },
    handleError (error) {
      let message = error.message
      switch (error.error) {
        case 205:
          message = 'Device ID is missing'
          break
        case 209:
          message = 'Device ID is not in the expected format'
          break
        case 305:
          // Device is not in DB
          message = 'No matches found'
          break
      }
      error.message = message
      EventBus.$emit(StatusBarEvent.ERROR, error.message)
    }
  }
}
